export const ORDER_EXECUTE_FETCH = 'ORDER_EXECUTE_FETCH';
export const ORDER_EXECUTE_DATA= 'ORDER_EXECUTE_DATA';
export const ORDER_EXECUTE_ERROR = 'ORDER_EXECUTE_ERROR';

export const ORDERS_SET_CURRENT_PRICE = 'ORDERS_SET_CURRENT_PRICE';
export const ORDERS_SET_AMOUNT = 'ORDERS_SET_AMOUNT';
export const ORDERS_SET_ORDER_TYPE = 'ORDERS_SET_ORDER_TYPE';
